import axios from "axios";

const SettingsService = {
  settings: null,
  async init() {
    var config = (await axios.get("config.json")).data;
    this.settings = config;
  },
};

export default SettingsService;
